<ng-container *ngIf="qrInfo">
  <div style="display: flex; justify-content: center">
    <qr-code [value]="qrInfo" size="500"></qr-code>
  </div>
  <button class="btn btn-primary w-100 d-print-none" (click)="print()">
    Print
  </button>
</ng-container>
